import React, { useReducer, useContext, useMemo } from "react";
import appReducer from "./AppReducer";
import ActionsHandler from "../Actions/ActionsHandler";
const AppContext = React.createContext(null);
export function useAppContext() {
    return useContext(AppContext);
}
export function AppProvider({ children }) {
    const initialState = {
        isLoading: false,
        selectedChat: {},
        newChats: false,
        chats: [],
        chatsListFilters: {},
        currentChatOption: { action: null, selectedChatId: null },
        workspaceConfig: {
            backend: { conversationOrderingType: null },
            agent: { showChatGroupsFilter: false },
        },
        conversationLabels: [],
        conversationTagGroups: [],
        chatSocketStatus: null,
        notificationSocketStatus: null,
    };
    const [appState, dispatch] = useReducer(appReducer, initialState);
    const actions = useMemo(() => ActionsHandler(dispatch), []);
    return <AppContext.Provider value={{ appState, actions }}>{children}</AppContext.Provider>;
}
export default AppContext;
